/**
 * PagarMe 3DS Status constants
 * Define the possible status values returned by the 3DS authentication process
 * @see https://docs.pagar.me/docs/manual-integracao-3ds#passo-6-finalizando-o-pedido
 */
export const PAGARME_3DS_STATUS = {
  success: 'Y',
  failure: 'N',
  challenge: 'C',
  unavailable: 'U',
  auth_try: 'A',
  denied: 'R',
  information: 'I',
} as const;

/**
 * Sizes for Pagar.me 3DS challenge
 * Define the dimensions of the popup/modal that will be displayed during the 3DS authentication process
 *
 * @description Values used to configure the size of the 3DS challenge window:
 * - XS (01): 250 x 400
 * - SM (02): 390 x 400
 * - MD (03): 500 x 600
 * - LG (04): 600 x 400
 * - FULL_SCREEN (05): Full screen
 */
export const PAGARME_3DS_CHALLENGE_WINDOW_SIZE = {
  XS: '01',
  SM: '02',
  MD: '03',
  LG: '04',
  FULL_SCREEN: '05',
} as const;
